import { render } from "./DeleteResourceConfirmationModal.vue?vue&type=template&id=a5f06ada&scoped=true&ts=true"
import script from "./DeleteResourceConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./DeleteResourceConfirmationModal.vue?vue&type=script&lang=ts"

import "./DeleteResourceConfirmationModal.vue?vue&type=style&index=0&id=a5f06ada&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5f06ada"]])

export default __exports__